export default __webpack_public_path__ + "static/media/opensans-300.17e98b9e.ttf";